import type { SrmSupplierAdmissionApplicationPage } from "@/types/apis";
import type { ProColumns } from "@ant-design/pro-components";

export function createTableColumns(
  t: (key: string) => string,
): ProColumns<SrmSupplierAdmissionApplicationPage>[] {
  return [
    {
      title: t("申请状态"),
      dataIndex: "viewStatus",
      key: "viewStatus",
    },
    {
      title: t("供应商编号"),
      dataIndex: "supplierCode",
      key: "supplierCode",
    },
    {
      title: t("供应商名称（中文）"),
      dataIndex: "supplierName",
      key: "supplierName",
      search: false,
    },
    {
      title: t("供应商名称"),
      dataIndex: "supplierName",
      key: "supplierName",
      hideInTable: true,
    },
    {
      title: t("供应商名称（英文）"),
      dataIndex: "supplierUsName",
      key: "supplierUsName",
      search: false,
    },
    {
      title: t("工厂"),
      dataIndex: "factoryName",
      key: "factoryName",
      search: false,
    },
    {
      title: t("物料类别"),
      dataIndex: "materialCategoryValue",
      key: "materialCategoryValue",
      hideInTable: true,
      valueType: "select",
      fieldProps: {
        options: [
          { label: "生产性物料", value: "PO" },
          { label: "非生产性物料", value: "nonPO" },
        ],
      },
    },
    {
      title: t("物料类别"),
      dataIndex: "materialCategoryName",
      key: "materialCategory",
      search: false,
    },
    {
      title: t("采购类型"),
      dataIndex: "purchaseTypeName",
      key: "purchaseTypeName",
      search: false,
    },
    {
      title: t("供应商地址"),
      dataIndex: "supplierAddress",
      key: "supplierAddress",
      search: false,
    },
    {
      title: t("经营有效期至"),
      dataIndex: "businessValidity",
      key: "businessValidity",
      search: false,
    },
    {
      title: t("联系人"),
      dataIndex: "registrantList",
      key: "contactPerson",
      search: false,
      render: (registrantList: any) => {
        return registrantList.name || "-";
      },
    },
    {
      title: t("联系人电话"),
      dataIndex: "registrantList",
      key: "contactPhone",
      search: false,
      render: (registrantList: any) => {
        return registrantList.phone || "-";
      },
    },
    {
      title: t("联系人邮箱"),
      dataIndex: "registrantList",
      key: "registrantEmail",
      search: false,
      render: (registrantList: any) => {
        return registrantList.email || "-";
      },
    },
    {
      title: t("货币"),
      dataIndex: "currencyName",
      key: "currencyName",
      search: false,
    },
    {
      title: t("付款方式"),
      dataIndex: "paymentMethodName",
      key: "paymentMethodName",
      search: false,
    },
    {
      title: t("付款条约"),
      dataIndex: "paymentTermsName",
      key: "paymentTermsName",
      search: false,
    },
    {
      title: t("国际贸易条款"),
      dataIndex: "internationalTradeTermsName",
      key: "internationalTradeTermsName",
      search: false,
    },
    {
      title: t("申请人"),
      dataIndex: "applicant",
      key: "applicant",
    },
    {
      title: t("申请时间"),
      dataIndex: "applicantDate",
      key: "applicantDate",
      search: false,
    },
  ];
}
